module.exports = __webpack_public_path__ + "img/fondo-socios-mobile.6e03f18d.png";